import { RootState } from 'rootReducer';

export const repPhotoSelector = (state: RootState) => state.securityModuleReducer.reportPhotoReducer;
